// === Dashboard/bookmark/Index.tsx ===
import React from "react";
import Loader from "../../../components/Loader";
import AppSimpleBar from "../../../components/AppSimpleBar";
import LeftbarTitle from "../../../components/LeftbarTitle";
import BookMark from "./BookMark";
import { useBookmark } from "../../../hooks/useBookmark";
import { useAuth } from "../../../context/AuthContext";

const Index = () => {
  const { favourites, loading, updateBookmark, deleteBookmark } = useBookmark();
  const { user } = useAuth();

  return (
    <div className="position-relative">
      {loading && <Loader />}
      <LeftbarTitle title="Bookmark" />


      <AppSimpleBar className="chat-message-list chat-bookmark-list">
        <ul className="list-unstyled chat-list">
          {favourites.map((favourite, key) => (
            <h1>Em construcao</h1>
            // <BookMark
            //   key={key}
            //   bookmark={bookmark}
            //   onUpdate={updateBookmark}
            //   onDelete={() => deleteBookmark(user?.id as number, bookmark.idContact as number)}
            // />
          ))}
        </ul>
      </AppSimpleBar>
    </div>
  );
};


export default Index;